enum CompanyGroupUserType {
  ADMIN = 'Admin',
  REGULAR = 'Regular',
}
export default CompanyGroupUserType
